export const FETCH_EQUIPMENT_REPORT = "FETCH_EQUIPMENT_REPORT";
export const FETCH_EQUIPMENT_REPORT_CONTINUE_SUCCESS = "FETCH_EQUIPMENT_REPORT_CONTINUE_SUCCESS";
export const FETCH_EQUIPMENT_REPORT_REFRESH_SUCCESS = "FETCH_EQUIPMENT_REPORT_REFRESH_SUCCESS";
export const FETCH_EQUIPMENT_REPORT_FAILURE = "FETCH_EQUIPMENT_REPORT_FAILURE";
